import React, {useEffect, useState} from 'react'
import mainStyles from "@/public/styles/common/app-download.module.scss";

export default function AppDefaultBanner() {
    const [show, setShow] = useState(false);
    const [isIphone, setIsIphone] = useState(false);
    const [link, setLink] = useState('');

    useEffect(() => {
        let isIphone = /^(iPhone|iPad|iPod|iPhone Simulator|iPad Simulator|iPod Simulator)/.test(navigator.platform);
        setIsIphone(isIphone);

        let href = `${isIphone
            ? process?.env?.NEXT_PUBLIC_APP_STORE_LINK
            : process?.env?.NEXT_PUBLIC_GOOGLE_PLAY_LINK}`

        setLink(href)

        setShow(true);
    }, []);

    if (!show) {
        return null;
    }

    return (
        <div className={mainStyles.appBanner}>
            <a href={link}
               onClick={
                   () => {
                       if (window.ym) {
                           window?.ym(86996338, 'reachGoal', 'click_app_link')
                           window?.ym(86996338, 'reachGoal', 'click_app_link_default')

                           if (isIphone) {
                               window?.ym(86996338, 'reachGoal', 'click_app_link_ios')
                           } else {
                               window?.ym(86996338, 'reachGoal', 'click_app_link_android')
                           }
                       }
                   }
               }>
                <img alt={`app banner`} src={'/images-local/app_default_new.jpg'}
                     width={576} height={406}/>
            </a>
        </div>

    )
}
